// Common
// Instructor IL
import simulatorTrainingInstructorILSchedulesLocale from 'modules/simulatorTrainings/instructor/instructorLed/Schedules/localization/en.json'
import simulatorTrainingInstructorILSimulatorListLocale from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/localization/en.json'
import simulatorTrainingInstructorILTrainingDetailsLocale from 'modules/simulatorTrainings/instructor/instructorLed/TrainingDetails/localization/en.json'
// Instructor SL
import simulatorTrainingInstructorSLExerciseListLocale from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/localization/en.json'
import simulatorTrainingInstructorSLSchedulesLocale from 'modules/simulatorTrainings/instructor/studentLed/Schedules/localization/en.json'
import simulatorTrainingInstructorSLTrainingDetailsLocale from 'modules/simulatorTrainings/instructor/studentLed/TrainingDetails/localization/en.json'
// Student IL
import simulatorTrainingStudentILTrainingDetailsLocale from 'modules/simulatorTrainings/student/instructorLed/TrainingDetails/localization/en.json'
// Student SL
import simulatorTrainingStudentSLTrainingDetailsLocale from 'modules/simulatorTrainings/student/studentLed/TrainingDetails/localization/en.json'
import simulatorTrainingLocale from './en.json'

const en = {
  simulatorTraining: simulatorTrainingLocale,
  instructor: {
    instructorLed: {
      simulatorList: simulatorTrainingInstructorILSimulatorListLocale,
      schedules: simulatorTrainingInstructorILSchedulesLocale,
      trainingDetails: simulatorTrainingInstructorILTrainingDetailsLocale,
    },
    studentLed: {
      exerciseList: simulatorTrainingInstructorSLExerciseListLocale,
      schedules: simulatorTrainingInstructorSLSchedulesLocale,
      trainingDetails: simulatorTrainingInstructorSLTrainingDetailsLocale,
    },
  },
  student: {
    instructorLed: {
      trainingDetails: simulatorTrainingStudentILTrainingDetailsLocale,
    },
    studentLed: {
      trainingDetails: simulatorTrainingStudentSLTrainingDetailsLocale,
    },
  },
}

export default en
